import { Background } from '../surfaces/background'
import { Container } from '@mui/material'
import FormattedImage from '../FormattedImage'
import type { ImageSectionAttributes } from '../../types/cms'
import { Title } from './styles'

/**
 * Titled image block (e.g. OBSERV lighting modes).
 * Strapi collection: Image Section · zone: `products.image-section` → `image_section`.
 */
const ImageSection = ({
  title,
  backgroundColour = '#000',
  image,
}: ImageSectionAttributes) => {
  if (!image) return null

  return (
    <Background bgColour={backgroundColour}>
      <Container maxWidth="lg">
        {title ? <Title>{title}</Title> : null}
        <FormattedImage image={image} responsive />
      </Container>
    </Background>
  )
}

export default ImageSection
